import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCog } from "@fortawesome/free-solid-svg-icons";
import { NavigationLink, NavigationContext } from "navigation-react";
import anihlogoimage from "./images/idclogo.png";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes" });

const DashboardContentHeader = () => {
  const { stateNavigator } = useContext(NavigationContext);
  const username = ls.get("username");
  const userpw = ls.get("userpw");
  const usercsrf_token = ls.get("usercsrf_token");
  // const userlogout_token = ls.get("userlogout_token");

  const handleLogout = async () => {
    fetch(`${process.env.REACT_APP_LOGOUT_API}?_format=json`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": usercsrf_token,
        Authorization: `Basic ${username}:${userpw}`,
      },
      withCredentials: true,
      credentials: "include",
    })
      .then(() => {
        ls.clear();
        stateNavigator.navigate("login");
      })
      .catch((error) => console.error("Logout error:", error));
  };

  return (
    <header className="top-menu">
      <div className="logo">
        <img src={anihlogoimage} alt="ANIH Logo" className="logo-image" />
        <h2>VOUCHER PORTAL</h2>
      </div>
      <nav className="auth-links">
        <ul>
          <li>
            <NavigationLink
              stateKey="edituserprofile"
              navigationData={{ userdata: username }}
            >
              <FontAwesomeIcon icon={faUserCog} />
              {username}
            </NavigationLink>
          </li>
          <li>
            <a href="#logout" onClick={handleLogout}>
              Logout
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default DashboardContentHeader;
